/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-closing-tag-location */
import React, { memo, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import Box from "@material-ui/core/Box";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import { injectIntl } from "react-intl";
import Hidden from "@material-ui/core/Hidden";

import { ADGMImage } from "aurora-components";

import Divider from "@material-ui/core/Divider";
import { keyEmptyCheck } from "aurora-utils/utils";

import styles from "./styles";
function ProjectSummary(props) {
  const { classes, locale, project, selectable, multi, selected, setSelected } = props;

  const isChecked = useMemo(() => {
    // For bulding, check for all units
    return multi && selected?.some((item) => item.id === project?.id);
  }, [multi, selected]);

  const isIndeterminate = useMemo(() => {
    return multi && !isChecked && selected?.some((item) => item.id === project?.id);
  }, [multi, isChecked, selected]);

  const onItemClick = useCallback(
    async (data) => {
      if (multi) {
        const newSelected = [...(selected || [])];
        const alreadyExist = newSelected.some((item) => item.id === data.id);
        if (alreadyExist) {
          setSelected(newSelected.filter((item) => item.id !== data.id));
        } else {
          setSelected([...newSelected, data]);
        }
        return;
      }

      if (selected?.id === data.id) {
        setSelected(null);
        return;
      }

      setSelected(data);
    },
    [multi, project, isIndeterminate, selected]
  );

  const isSelected = useMemo(
    () =>
      multi
        ? (selected || [])?.find((selectedProject) => selectedProject?.id === project?.id) !== undefined
        : selected
        ? selected?.id === project?.id
        : false,
    [project, selected, multi]
  );

  const projectDetail = useMemo(() => {
    return {
      id: project?.id,
      name: locale === "ar" ? project?.nameAr : project?.name,
      status: keyEmptyCheck(project?.elmsStatus || project?.projectStatus || project?.status),
      projectNumber: project?.projectNumber,
      buildingUsage: project?.buildingUsage === "MIXED_USE" ? keyEmptyCheck("mixed") : keyEmptyCheck(project?.buildingUsage),
      type: keyEmptyCheck(project?.type),
      progressPercentage: project?.progressPercentage,
      projectCategoryDesc: project?.projectCategoryDesc || project?.category || "",
      projectImage: project?.projectImage,
      isMortgaged: project?.isMortgaged || project?.isMortgage,
      isOffPlan: project?.isOffPlan,
      address:
        locale === "ar"
          ? `${project?.districtAr}, ${project?.communityAr}`
          : `${project?.districtEn}, ${project?.communityEn}`,
    };
  }, [locale, project]);

  const isUnderConstruction = project?.status === "UNDER_CONSTRUCTION";
  const isReady = project?.status === "READY";
  const isCompleted = (project?.elmsStatus || project?.status)?.toLowerCase() === "completed"; 
  const isNew = project?.elmsStatus?.toLowerCase() === "new"; 

  return (
    <>
      <div
        className={classNames(classes.listItemContainer, {
          [classes.listItemContainerChecked]: isSelected,
        })}
      >
        <ListItem disableRipple={!selectable} dense button={selectable} {...(selectable ? { onClick: () => onItemClick(project) } : {})}>
          <ListItemText
            primary={
              <div className={classNames(classes.containerItem)}>
                <Box
                  sx={{
                    display: "flex",
                    gap: "12px",
                    width: "100%",
                  }}
                >
                  <Hidden smDown>
                    {selectable &&
                      (multi ? (
                        <Checkbox
                          edge="start"
                          checked={isChecked || false}
                          indeterminate={isIndeterminate || false}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ "aria-labelledby": project?.id }}
                          classes={{
                            root: classes.itemCheckbox,
                            checked: classes.itemCheckboxChecked,
                            indeterminate: classes.itemCheckboxIndeterminate,
                          }}
                        />
                      ) : (
                        <Radio
                          edge="start"
                          checked={selected?.id === project?.id || false}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ "aria-labelledby": project?.id }}
                          classes={{
                            root: classes.itemCheckbox,
                            checked: classes.itemCheckboxChecked,
                          }}
                        />
                      ))}
                  </Hidden>
                  <Hidden smDown>
                    <ADGMImage className={classes.projectImage} httpURL={projectDetail?.projectImage} name="Project?.svg" />
                  </Hidden>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      width: "100%",
                    }}
                  >
                    <Box className={classes.contentArea}>
                      <Box className={classes.contentAreaText}>
                        <Hidden mdUp>
                          <ADGMImage className={classes.projectImage} httpURL={projectDetail?.projectImage} name="Project?.svg" />
                        </Hidden>
                        <Box className={classes.textContainer}>
                          <Typography className={classes.title}>{projectDetail?.name}</Typography>
                          <Typography className={classes.subTitle}>
                            {keyEmptyCheck("project_number")} : {projectDetail?.projectNumber}
                          </Typography>
                        </Box>
                        <Hidden smDown>
                          <Box className={classes.badgeContainer}>
                            {projectDetail?.status && (
                              <Box className={classes.badge}>
                                <Box className={classNames({ [classes.danger]: isUnderConstruction, [classes.success]: isReady || isCompleted, [classes.infoColor]: isNew })} />
                                {projectDetail?.status}
                              </Box>
                            )}
                            {projectDetail?.isMortgaged && (
                              <Box className={classes.badge}>
                                <Box className={classes.danger} />
                                {keyEmptyCheck("mortgage")}
                              </Box>
                            )}
                          </Box>
                        </Hidden>
                      </Box>
                      <Hidden mdUp>
                        {selectable &&
                          (multi ? (
                            <Checkbox
                              edge="start"
                              checked={isChecked || false}
                              indeterminate={isIndeterminate || false}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": project?.id }}
                              classes={{
                                root: classes.itemCheckbox,
                                checked: classes.itemCheckboxChecked,
                                indeterminate: classes.itemCheckboxIndeterminate,
                              }}
                            />
                          ) : (
                            <Radio
                              edge="start"
                              checked={selected?.id === project?.id || false}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": project?.id }}
                              classes={{
                                root: classes.itemCheckbox,
                                checked: classes.itemCheckboxChecked,
                              }}
                            />
                          ))}
                      </Hidden>
                      <Hidden mdDown>
                        <Box sx={{ display: "flex", gap: "8px" }}>
                          {projectDetail?.projectCategoryDesc && (
                            <Box className={classNames(classes.infoChipButton, classes.infoColor)}>
                              {keyEmptyCheck(projectDetail?.projectCategoryDesc)}
                            </Box>
                          )}
                          {projectDetail?.type && <Box className={classNames(classes.infoChipButton, classes.success)}>{projectDetail?.type}</Box>}
                        </Box>
                      </Hidden>
                    </Box>

                    <Hidden lgUp>
                      <Box sx={{ display: "flex", gap: "8px" }}>
                        {projectDetail?.projectCategoryDesc && (
                          <Box className={classNames(classes.infoChipButton, classes.infoColor)}>
                            {keyEmptyCheck(projectDetail?.projectCategoryDesc)}
                          </Box>
                        )}
                        {projectDetail?.type && <Box className={classNames(classes.infoChipButton, classes.success)}>{projectDetail?.type}</Box>}
                      </Box>
                    </Hidden>

                    <Hidden mdUp>
                      <Box className={classes.badgeContainer}>
                        {projectDetail?.isOffPlan && (
                          <Box className={classes.badge}>
                            <Box className={classes.infoBadge} />
                            {keyEmptyCheck("offplan")}
                          </Box>
                        )}
                        {projectDetail.isMortgaged && (
                          <Box className={classes.badge}>
                            <Box className={classes.danger} />
                            {keyEmptyCheck("mortgage")}
                          </Box>
                        )}
                        {projectDetail?.status && (
                          <Box className={classes.badge}>
                            <Box className={classNames({ [classes.danger]: isUnderConstruction, [classes.success]: isReady || isCompleted })} />
                            {projectDetail?.status}
                          </Box>
                        )}
                      </Box>
                    </Hidden>
                    <Divider className={classes.divider} />
                    <Box className={classes.addressContainer}>
                      <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
                        <ADGMImage name="project-location-new.svg" />
                        <Typography className={classes.footerText}>{projectDetail?.address}</Typography>
                      </Box>
                      <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
                        {projectDetail?.progressPercentage > 0 && (
                          <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
                            <ADGMImage name="project-pie-chart.svg" />
                            <Typography className={classes.footerText}>
                              {projectDetail?.progressPercentage} % {keyEmptyCheck("completion_listing")}
                            </Typography>
                          </Box>
                        )}
                        {projectDetail?.buildingUsage && (
                          <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
                            <ADGMImage name="project-building-new.svg" />
                            <Typography className={classes.footerText}>{projectDetail?.buildingUsage}</Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </div>
            }
          />
        </ListItem>
      </div>
    </>
  );
}

ProjectSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
  selectable: PropTypes.bool,
  multi: PropTypes.bool,
  selected: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  setSelected: PropTypes.func,
};

ProjectSummary.defaultProps = {
  selected: null,
  selectable: false,
  multi: false,
  setSelected: null,
};

export default withStyles(styles)(injectIntl(memo(ProjectSummary)));
